import React from 'react'
import MasterFormModal from '../../generatedFormModal/MasterFormModal'

const EditMaster = () => {
  return (
    <div>
      <MasterFormModal  isEdit={true} />
    </div>
  )
}

export default EditMaster
